import Vue from 'vue'
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    jobs: [],
    loading: false,
    error: null,
  },
  getters: {
    jobs: state => state.jobs,
    loading: state => state.loading,
    error: state => state.error,
  },
  mutations: {
    SET_JOBS(state, payload) {
      state.jobs = payload
    },
    ADD_JOB(state, payload) {
      state.jobs.unshift(payload)
    },
    UPDATE_JOB(state, payload) {
      const index = state.jobs.findIndex(
        job => job.id === payload.id,
      )
      Vue.set(state.jobs, index, payload)
    },
    DELETE_JOB(state, payload) {
      const index = state.jobs.findIndex(
        job => job.id === payload,
      )
      state.jobs.splice(index, 1)
    },
    SET_LOADING: (state, payload) => {
      state.loading = payload
    },
    SET_ERROR: (state, payload) => {
      state.error = payload
    },
    // eslint-disable-next-line no-return-assign
    CLEAR_ERROR: state => (state.error = null),
  },
  actions: {
    async getJobs({ commit }) {
      try {
        commit('SET_LOADING', true)
        const { data } = await axiosIns.get('/jobs/')
        commit('SET_JOBS', data)
        commit('SET_LOADING', false)
      } catch (error) {
        commit('SET_LOADING', false)
      }
    },
    async addJob({ commit }, payload) {
      try {
        commit('CLEAR_ERROR')
        commit('SET_LOADING', true)
        const { data } = await axiosIns.post('/jobs/create/', payload)
        commit('ADD_JOB', data)
        commit('SET_LOADING', false)
      } catch (error) {
        commit('SET_LOADING', false)
        commit('SET_ERROR', error)
      }
    },
    async updateJob({ commit }, payload) {
      try {
        const { data } = await axiosIns.put(
          `/jobs/update/${payload.id}/`,
          payload,
        )
        commit('UPDATE_JOB', data)
        commit('SET_LOADING', false)
      } catch (error) {
        commit('SET_LOADING', false)
        commit('SET_ERROR', error)
      }
    },
    async deleteJob({ commit }, payload) {
      try {
        await axiosIns.delete(`/jobs/delete/${payload}`)
        commit('DELETE_JOB', payload)
        commit('SET_LOADING', false)
      } catch (error) {
        commit('SET_LOADING', false)
        commit('SET_ERROR', error)
      }
    },
  },
}
